export enum SupplierDictCodeEnmu {
    //供应商类别 贸易商
    SUPPLIER_CATEGORY_TRADERS = 'supplier.category.traders',
    //供应商类别 服务站
    SUPPLIER_CATEGORY_SERVICESTATION = 'supplier.category.serviceStation',
    //供应商类别 经销商
    SUPPLIER_CATEGORY_DEALER = 'supplier.category.dealer',


    //供应商企业性质 个人
    SUPPLIER_ENTERPRISENATURE_PERSON = 'supplier.enterpriseNature.person',
    //供应商企业性质 企业
    SUPPLIER_ENTERPRISENATURE_ENTERPRISE = 'supplier.enterpriseNature.enterprise',
    //供应商企业性质 销商务站
    SUPPLIER_ENTERPRISENATURE_SALESBUSINESSSTATION = 'supplier.enterpriseNature.salesBusinessStation',

    //供应商类型 主机厂配件
    SUPPLIER_TYPE_OEMACCESSORIES = 'supplier.type.OEMAccessories',
    //供应商类型 OE件
    SUPPLIER_TYPE_OECOMPONENT = 'supplier.type.OEComponent',
    //供应商类型 工时
    SUPPLIER_TYPE_WORKINGHOURS = 'supplier.type.workingHours',
    //供应商类型 经销商
    SUPPLIER_TYPE_DEALER = 'supplier.type.dealer',


    //询价对比订单状态 已开单
    INQUIRY_STATUS_CREATE = 'inquiry.create',
    //询价对比订单状态 已开单
    INQUIRY_STATUS_SUBMIT = 'inquiry.submit',

}
